<script setup>
defineProps({
  selected: { type: String, default: '' },
});

const emit = defineEmits(['select']);

// WhatsApp keeps a single reaction per person, so this mirrors the quick row its own app offers.
const QUICK_REACTIONS = ['👍', '❤️', '😂', '😮', '😢', '🙏'];
</script>

<template>
  <div class="flex gap-1">
    <button
      v-for="emoji in QUICK_REACTIONS"
      :key="emoji"
      type="button"
      class="flex justify-center items-center text-lg rounded transition-colors cursor-pointer size-8 hover:bg-n-alpha-2"
      :class="{ 'bg-n-blue-3': emoji === selected }"
      @click.stop="emit('select', emoji)"
    >
      {{ emoji }}
    </button>
  </div>
</template>
